import { FileText, Stamp, FileCheck, ScrollText } from "lucide-react";
import { Link } from "react-router-dom";

const SERVICES = [
    { icon: Stamp, title: "Stamp Duty Guidance", desc: "State-wise calculations, payment, and e-stamping support." },
    { icon: FileText, title: "Property Registration", desc: "End-to-end sub-registrar coordination, biometric, and digital records." },
    { icon: FileCheck, title: "Document Upload & Tracking", desc: "Upload sale deed, agreement, ID proofs — track verification status digitally." },
    { icon: ScrollText, title: "Tax Consultation", desc: "Capital gains, TDS, GST, and section 54 advisory." },
];

export default function LegalServices() {
    return (
        <div className="min-h-screen bg-navy-900">
            <section className="bg-navy-950 border-b border-white/5">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
                    <div className="label-overline mb-3">Documentation Services</div>
                    <h1 className="font-heading text-4xl lg:text-6xl font-bold text-white max-w-3xl">Paperwork that protects your <span className="text-gold-500">biggest asset.</span></h1>
                    <p className="text-white/65 mt-4 max-w-2xl">From stamp duty to tax filings — every document handled by verified professionals with transparent pricing.</p>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 stagger">
                    {SERVICES.map((s) => {
                        const Icon = s.icon;
                        return (
                            <div key={s.title} className="rounded-2xl bg-navy-800 border border-white/5 p-8 hover:border-gold-500/40 hover-lift">
                                <div className="w-12 h-12 rounded-lg bg-gold-500/10 border border-gold-500/30 flex items-center justify-center mb-5">
                                    <Icon className="w-6 h-6 text-gold-500" />
                                </div>
                                <h3 className="font-heading text-2xl font-bold text-white mb-2">{s.title}</h3>
                                <p className="text-white/65 leading-relaxed">{s.desc}</p>
                            </div>
                        );
                    })}
                </div>
                <div className="mt-12 text-center">
                    <Link to="/contact" data-testid="legal-cta" className="inline-block px-8 py-4 rounded-md bg-gold-500 text-navy-900 font-semibold hover:bg-gold-100 transition-colors">Talk to a Documentation Expert</Link>
                </div>
            </section>
        </div>
    );
}
